import { GET_UNREAD_CONNECTION } from '../../actiontypes'

export const UnreadConnectionFetchReducer = (unreadConnmsg) => {
    return (dispatch) => {
            dispatch({ type: GET_UNREAD_CONNECTION, payload: unreadConnmsg});
    }      
};